import { RouteObject } from 'react-router-dom';

import Lifecycle from './index';

import PrivateRoute from '@/routes/PrivateRoute';
import ROUTES from '@/routes/routes';
import { UserRoleEnum } from '@/types/graphql';

const lifecycleRoute: RouteObject = {
  path: ROUTES.lifecycle,
  element: (
    <PrivateRoute
      element={<Lifecycle />}
      requiredRoles={[UserRoleEnum.TENANT_ADMIN, UserRoleEnum.HELPDESK_ADMIN]}
    />
  ),
};

export default lifecycleRoute;
